import React from 'react';
import PropTypes from 'prop-types';
import { roundNumber } from 'utils/general';
import { SPECIAL_INSTITUTIONS_TABLE_LABELS } from 'constants/countryProfile';

function SpecialInstitutions(props) {
  const { data, sector } = props;
  const specialInst = SPECIAL_INSTITUTIONS_TABLE_LABELS[data['institution-type']];
  const revenueValue = data['revenue-value'] ? `${data['revenue-value'].toLocaleString()} ${data['revenue-unit']}` : 'N/A';
  const hasTwoRanks = data['institution-type'] !== 'Sovereign wealth fund governance';
  return (
    <article className="c-special-institutions">
      <div className="row">
        <div className="column small-12 medium-10 medium-offset-1">
          <h1 className="-light">{data['institution-type']}</h1>
          <h2 className="subtitle linght" dangerouslySetInnerHTML={{ __html: data.title }}></h2>
        </div>
      </div>
      <div className="row">
        <div className="column small-12 medium-10 medium-offset-1">
          <p dangerouslySetInnerHTML={{ __html: data.description }}></p>
        </div>
      </div>

      <div className="row">
        <div className="table column small-12 medium-10 medium-offset-1">
          <table className="c-table">
            <thead>
              <tr>
                <th>{specialInst.nameLabel}</th>
                {hasTwoRanks && <th className="">{specialInst.percentageLabel}</th>}
                <th className="">{specialInst.valueLabel}</th>
                <th className="punctuation">Score (/100)</th>
                <th className="punctuation">Rank <span>{specialInst.ranks.rank1}</span></th>
                {hasTwoRanks && <th className="punctuation">Rank <span>{specialInst.ranks.rank2[sector]}</span></th>}
                {/* <td></td> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data.name}</td>
                {hasTwoRanks && <td>{data.percentage}%</td>}
                <td className="">{revenueValue}</td>
                <td className="punctuation">{roundNumber(data.score)}</td>
                <td className="punctuation">{data['rank-1']}</td>
                {hasTwoRanks && <td className="punctuation">{data['rank-2'] ? `${data['rank-2']}` : '-'}</td>}
                {/* <td className="icon-cell">
                  <span className="icon -up"></span>
                </td> */}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </article>
  );
}

SpecialInstitutions.propTypes = {
  data: PropTypes.object,
  sector: PropTypes.string
};

export default SpecialInstitutions;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/SpecialInstitutions.jsx